<app-page-wrapper
  [title]="(view === 'home' ? 'pluginsHomeTitle' : 'pluginsAddToolsAndPlugins') | i18n"
>
  @if (view === "home") {
    <div class="tw-flex tw-flex-col tw-w-full tw-gap-4" data-testid="plugins-home">
      <!--      toolbar: search + add new-->
      <div class="tw-flex tw-items-center tw-gap-3 tw-w-full">
        <app-search-input
          class="tw-w-[360px] tw-max-w-full"
          [sunken]="true"
          [iconLeading]="true"
          [clearable]="true"
          [placeholder]="'pluginsHomeSearchPlaceholder' | i18n"
          [(value)]="homeSearchQuery"
        ></app-search-input>
        <div class="tw-flex-1"></div>
        <button
          type="button"
          data-testid="plugins-add-new"
          [attr.aria-label]="'pluginsAddNew' | i18n"
          class="tw-flex tw-items-center tw-justify-center tw-gap-2 tw-h-10 tw-px-6 tw-shrink-0 tw-rounded-2xl tw-bg-color-intent-brand tw-text-color-text-on-action tw-text-sm tw-font-semibold tw-shadow-elevation-control"
          (click)="showStore()"
        >
          <icon [name]="'plus'" [size]="4"></icon>
          <span class="">{{ "pluginsAddNew" | i18n }}</span>
        </button>
      </div>

      @if (homeSearch; as s) {
        <!--      search results: your tools, your plugins, then what is still in Add new-->
        <div
          class="tw-flex tw-flex-wrap tw-items-baseline tw-gap-1.5 tw-text-sm"
          data-testid="search-resline"
        >
          <b class="tw-font-bold tw-text-color-text-default">{{
            s.total === 0
              ? ("pluginsSearchNoResults" | i18n: s.query)
              : s.total === 1
                ? ("pluginsSearchResultOne" | i18n: s.query)
                : ("pluginsSearchResultMany" | i18n: s.total : s.query)
          }}</b>
          <span class="tw-text-xs tw-font-medium tw-text-color-text-tertiary">{{
            s.subKey | i18n
          }}</span>
        </div>

        @if (s.kind === "none") {
          <div
            class="tw-flex tw-flex-col tw-items-center tw-gap-3 tw-px-6 tw-py-10 tw-text-center tw-rounded-2xl tw-bg-color-surface-card tw-shadow-elevation-card"
            data-testid="search-empty"
          >
            <h3 class="tw-m-0 tw-text-lg tw-font-semibold tw-text-color-text-default">
              {{ "pluginsSearchEmptyTitle" | i18n: s.query }}
            </h3>
            <p class="tw-m-0 tw-text-sm tw-text-color-text-secondary">
              {{ "pluginsSearchEmptyText" | i18n }}
            </p>
            <button
              type="button"
              class="tw-h-10 tw-px-5 tw-rounded-xl tw-bg-color-surface-card tw-text-sm tw-font-semibold tw-text-color-text-action tw-shadow-elevation-control"
              (click)="showStore()"
            >
              {{ "pluginsBrowseAddNew" | i18n }}
            </button>
          </div>
        } @else {
          @if (s.noteKey && (s.kind === "notinst" || s.kind === "mixed")) {
            <div
              class="tw-flex tw-items-center tw-gap-2 tw-text-[13px] tw-font-medium tw-text-color-text-secondary"
              data-testid="search-note"
            >
              <icon [name]="'info-circle'" [size]="4" [currentColor]="'color-text-tertiary'"></icon>
              {{ s.noteKey | i18n: s.query }}
            </div>
          }

          @if (s.tools.length) {
            <section
              class="tw-px-4 tw-py-1 tw-rounded-2xl tw-bg-color-surface-card tw-shadow-elevation-card"
              data-testid="search-tools"
            >
              <div
                class="tw-flex tw-items-center tw-gap-2 tw-h-11 tw-text-[13px] tw-font-bold tw-uppercase tw-tracking-[0.06em] tw-text-color-text-secondary"
              >
                {{ "pluginsYourTools" | i18n }}
                <span class="tw-font-medium tw-text-color-text-tertiary">{{ s.tools.length }}</span>
                <span
                  class="tw-ml-auto tw-text-xs tw-font-medium tw-normal-case tw-tracking-normal tw-text-color-text-tertiary"
                  >{{ "pluginsSearchClickToOpen" | i18n }}</span
                >
              </div>
              <div class="">
                @for (tile of s.tools; track tile.id) {
                  <button
                    type="button"
                    class="tw-flex tw-items-center tw-gap-3.5 tw-w-full tw-py-3 tw-text-left tw-border-0 tw-border-t tw-border-solid tw-border-color-border-subtle"
                    [attr.data-testid]="'search-tool-' + tile.id"
                    (click)="openTool(tile)"
                  >
                    <span
                      class="tw-flex tw-items-center tw-justify-center tw-size-11 tw-shrink-0 tw-rounded-[14px] tw-bg-color-surface-elevated tw-shadow-elevation-control"
                    >
                      <icon
                        [name]="tile.icon"
                        [size]="6"
                        [currentColor]="'color-text-action'"
                      ></icon>
                    </span>
                    <span class="tw-flex tw-flex-col tw-flex-1 tw-min-w-0">
                      <span
                        class="tw-truncate tw-text-sm tw-font-semibold tw-text-color-text-default"
                        >{{ tile.labelKey | i18n }}</span
                      >
                      <span class="tw-truncate tw-text-xs tw-text-color-text-tertiary">{{
                        pluginMeta(tile.plugin)
                      }}</span>
                    </span>
                    @if (badgeCount(tile) > 0) {
                      <span
                        class="tw-flex tw-items-center tw-h-7 tw-px-3 tw-rounded-full tw-bg-color-accent-today-bg tw-text-xs tw-font-semibold tw-text-color-text-action"
                        >{{ "pluginsBadgeDetected" | i18n: badgeLabel(badgeCount(tile)) }}</span
                      >
                    }
                    <span
                      class="tw-flex tw-items-center tw-gap-1 tw-text-sm tw-font-semibold tw-text-color-text-action"
                    >
                      {{ "pluginsOpen" | i18n }}
                      <icon [name]="'right-arrow'" [size]="4" [disableArrowOverride]="true"></icon>
                    </span>
                  </button>
                }
              </div>
            </section>
          }

          @if (s.plugins.length) {
            <section
              class="tw-px-4 tw-py-1 tw-rounded-2xl tw-bg-color-surface-card tw-shadow-elevation-card"
              data-testid="search-plugins"
            >
              <div
                class="tw-flex tw-items-center tw-gap-2 tw-h-11 tw-text-[13px] tw-font-bold tw-uppercase tw-tracking-[0.06em] tw-text-color-text-secondary"
              >
                {{ "pluginsYourPlugins" | i18n }}
                <span class="tw-font-medium tw-text-color-text-tertiary">{{
                  s.plugins.length
                }}</span>
                <span
                  class="tw-ml-auto tw-text-xs tw-font-medium tw-normal-case tw-tracking-normal tw-text-color-text-tertiary"
                  >{{ "pluginsSearchStatusAndManage" | i18n }}</span
                >
              </div>
              <div class="">
                @for (plugin of s.plugins; track plugin.id) {
                  <div
                    class="tw-flex tw-items-center tw-gap-3.5 tw-py-3 tw-border-0 tw-border-t tw-border-solid tw-border-color-border-subtle"
                    [attr.data-testid]="'search-plugin-' + plugin.id"
                  >
                    <span
                      class="tw-flex tw-items-center tw-justify-center tw-size-11 tw-shrink-0 tw-rounded-[14px] tw-bg-color-surface-sunken tw-text-sm tw-font-semibold tw-text-color-text-secondary"
                      >{{ plugin.title.charAt(0) }}</span
                    >
                    <span class="tw-flex tw-flex-col tw-flex-1 tw-min-w-0">
                      <span
                        class="tw-truncate tw-text-sm tw-font-semibold tw-text-color-text-default"
                        >{{ plugin.title }}</span
                      >
                      <span class="tw-truncate tw-text-xs tw-text-color-text-tertiary">{{
                        pluginMeta(plugin)
                      }}</span>
                    </span>
                    <span
                      class="tw-flex tw-items-center tw-h-7 tw-px-3 tw-rounded-full tw-bg-color-status-success-bg tw-text-xs tw-font-semibold tw-text-color-status-success-text"
                      >{{ "pluginsStatusActive" | i18n }}</span
                    >
                    <button
                      type="button"
                      class="tw-h-9 tw-px-3.5 tw-rounded-xl tw-bg-color-surface-card tw-text-[13px] tw-font-semibold tw-text-color-text-action tw-shadow-elevation-control"
                      (click)="openPlugin(plugin)"
                    >
                      {{ "pluginsManage" | i18n }}
                    </button>
                  </div>
                }
              </div>
            </section>
          }

          @if (s.noteKey && (s.kind === "tools" || s.kind === "plugins")) {
            <div
              class="tw-flex tw-items-center tw-gap-2 tw-text-[13px] tw-font-medium tw-text-color-text-secondary"
              data-testid="search-note"
            >
              <icon [name]="'info-circle'" [size]="4" [currentColor]="'color-text-tertiary'"></icon>
              {{ s.noteKey | i18n: s.query }}
            </div>
          }

          @if (s.notInstalled.length) {
            <section
              class="tw-px-4 tw-py-1 tw-rounded-2xl tw-bg-color-surface-card tw-shadow-elevation-card"
              data-testid="search-not-installed"
            >
              <div
                class="tw-flex tw-items-center tw-gap-2 tw-h-11 tw-text-[13px] tw-font-bold tw-uppercase tw-tracking-[0.06em] tw-text-color-text-secondary"
              >
                {{ "pluginsSearchNotInstalled" | i18n }}
                <span class="tw-font-medium tw-text-color-text-tertiary">{{
                  s.notInstalled.length
                }}</span>
                <span
                  class="tw-ml-auto tw-text-xs tw-font-medium tw-normal-case tw-tracking-normal tw-text-color-text-tertiary"
                  >{{ "pluginsSearchInstallHint" | i18n }}</span
                >
              </div>
              <div class="">
                @for (plugin of s.notInstalled; track plugin.id) {
                  <div
                    role="button"
                    tabindex="0"
                    class="tw-flex tw-items-center tw-gap-3.5 tw-py-3 tw-cursor-pointer tw-border-0 tw-border-t tw-border-solid tw-border-color-border-subtle"
                    [attr.data-testid]="'search-not-installed-' + plugin.id"
                    (click)="openFromCard(plugin)"
                    (keydown.enter)="onCardKeydown(plugin, $event)"
                    (keydown.space)="onCardKeydown(plugin, $event)"
                  >
                    <span
                      class="tw-flex tw-items-center tw-justify-center tw-size-11 tw-shrink-0 tw-rounded-[14px] tw-bg-color-surface-sunken tw-text-sm tw-font-semibold tw-text-color-text-secondary"
                      >{{ monogram(plugin) }}</span
                    >
                    <span class="tw-flex tw-flex-col tw-flex-1 tw-min-w-0">
                      <span
                        class="tw-truncate tw-text-sm tw-font-semibold tw-text-color-text-default"
                        >{{ plugin.title }}</span
                      >
                      <span class="tw-truncate tw-text-xs tw-text-color-text-tertiary">{{
                        pluginMeta(plugin)
                      }}</span>
                    </span>
                    <span
                      class="tw-flex tw-items-center tw-h-7 tw-px-3 tw-rounded-full tw-bg-color-surface-sunken tw-text-xs tw-font-semibold tw-text-color-text-secondary"
                      >{{ priceLabel(plugin) }}</span
                    >
                    <button
                      type="button"
                      class="tw-h-9 tw-px-3.5 tw-rounded-xl tw-bg-color-intent-brand tw-text-[13px] tw-font-semibold tw-text-color-text-on-action tw-shadow-elevation-control"
                      (click)="openFromCard(plugin, $event)"
                    >
                      {{ "pluginsInstall" | i18n }}
                    </button>
                  </div>
                }
              </div>
            </section>
            <div>
              <button
                type="button"
                class="tw-flex tw-items-center tw-gap-1 tw-text-sm tw-font-semibold tw-text-color-text-action"
                data-testid="search-see-in-add-new"
                (click)="showStore(undefined, s.query)"
              >
                {{ "pluginsSearchSeeInAddNew" | i18n: s.query }}
                <icon [name]="'right-arrow'" [size]="4" [disableArrowOverride]="true"></icon>
              </button>
            </div>
          }
        }
      } @else {
        <!--      your tools-->
        <section
          *ngIf="toolsView as tools"
          class="tw-flex tw-flex-col tw-gap-3 tw-p-4 tw-rounded-2xl tw-bg-color-surface-card tw-shadow-elevation-card"
          data-testid="plugins-your-tools"
        >
          <div class="tw-flex tw-items-center tw-gap-2" data-testid="tools-header">
            <span
              class="tw-text-base tw-font-semibold tw-text-color-text-default tw-whitespace-nowrap"
              >{{ "pluginsYourTools" | i18n }}</span
            >
            <span class="tw-text-[13px] tw-font-medium tw-text-color-text-tertiary">{{
              tools.visible.length
            }}</span>
            <div class="tw-flex-1"></div>
            <span class="tw-text-xs tw-font-medium tw-text-color-text-tertiary">{{
              "pluginsDragToReorder" | i18n
            }}</span>
            <span id="tools-reorder-hint" class="tw-sr-only">{{
              "pluginsReorderKeyboardHint" | i18n
            }}</span>
            @if (toolPrefs.order().length > 0) {
              <span class="tw-w-px tw-h-[14px] tw-bg-color-border-strong"></span>
              <button
                type="button"
                class="tw-text-sm tw-font-semibold tw-text-color-text-action tw-whitespace-nowrap"
                data-testid="tools-reset-order"
                (click)="resetToolOrder()"
              >
                {{ "pluginsResetOrder" | i18n }}
              </button>
            }
            <span class="tw-w-px tw-h-[14px] tw-bg-color-border-strong"></span>
            <button
              type="button"
              class="tw-text-sm tw-font-semibold tw-text-color-text-action tw-whitespace-nowrap"
              data-testid="tools-edit"
              [attr.aria-label]="'pluginsEditYourTools' | i18n"
              (click)="openEditTools()"
            >
              {{ "pluginsEditTools" | i18n }}
            </button>
            @if (tools.canExpand) {
              <span class="tw-w-px tw-h-[14px] tw-bg-color-border-strong"></span>
              <button
                type="button"
                class="tw-flex tw-items-center tw-gap-1 tw-text-sm tw-font-semibold tw-text-color-text-action tw-whitespace-nowrap"
                data-testid="tools-show-all"
                [attr.aria-expanded]="toolsExpanded"
                (click)="toggleToolsExpanded()"
              >
                <span>{{
                  toolsExpanded
                    ? ("pluginsShowLess" | i18n)
                    : ("pluginsShowAll" | i18n: tools.visible.length)
                }}</span>
                <icon
                  [name]="'chevron-down'"
                  [size]="4"
                  [ngClass]="{ 'tw-rotate-180': toolsExpanded }"
                ></icon>
              </button>
            }
          </div>
          <span class="tw-sr-only" role="status" aria-live="polite">{{
            toolReorderAnnouncement
          }}</span>
          <!-- Count badge on a tile's top right; hidden from screen readers (the count is read via the
             tile's sr-only text instead). -->
          <ng-template #toolBadge let-count>
            @if (count > 0) {
              <span
                aria-hidden="true"
                class="tw-absolute tw-left-[42px] -tw-top-1.5 tw-flex tw-items-center tw-justify-center tw-h-5 tw-px-1.5 tw-rounded-full tw-border-2 tw-border-solid tw-border-color-surface-elevated tw-bg-color-intent-brand tw-text-[10px] tw-font-semibold tw-leading-[14px] tw-text-color-text-on-action"
                data-testid="tool-badge"
                >{{ badgeLabel(count) }}</span
              >
            }
          </ng-template>
          <div
            #toolsGrid
            *ngIf="toolPrefsReady"
            class="tw-flex tw-flex-wrap tw-gap-x-2 tw-gap-y-4"
            cdkDropList
            cdkDropListOrientation="mixed"
            data-testid="tools-grid"
            (cdkDropListDropped)="onToolDrop($event)"
          >
            @for (tile of tools.displayed; track tile.id; let i = $index) {
              <button
                type="button"
                cdkDrag
                [cdkDragData]="tile"
                [cdkDragStartDelay]="{ touch: 300, mouse: 0 }"
                class="tw-flex tw-flex-col tw-items-center tw-gap-[9px] tw-w-[134px] tw-shrink-0 tw-cursor-grab active:tw-cursor-grabbing [&.cdk-drag-animating]:tw-transition-transform [&.cdk-drag-animating]:tw-duration-200"
                [attr.data-testid]="'tool-tile-' + tile.id"
                aria-keyshortcuts="Alt+ArrowLeft Alt+ArrowRight"
                aria-describedby="tools-reorder-hint"
                (click)="openTool(tile)"
                (keydown)="onToolKeydown($event, i)"
              >
                <!-- Dashed slot marking where the tile will land; same footprint as a tile so
                   neighbours shift out of the way instead of overlapping it. -->
                <div
                  *cdkDragPlaceholder
                  class="tw-w-[134px] tw-min-h-[81px] tw-self-stretch tw-shrink-0 tw-rounded-2xl tw-border-[1.5px] tw-border-dashed tw-border-color-border-strong"
                ></div>
                <!-- Floating copy that follows the pointer, kept above the grid. -->
                <ng-template cdkDragPreview [matchSize]="true">
                  <div
                    class="tw-flex tw-flex-col tw-items-center tw-gap-[9px] tw-w-full tw-cursor-grabbing tw-pointer-events-none"
                  >
                    <span
                      class="tw-relative tw-flex tw-items-center tw-justify-center tw-size-14 tw-rounded-[18px] tw-bg-color-surface-elevated tw-shadow-elevation-card"
                    >
                      <icon
                        [name]="tile.icon"
                        [size]="6"
                        [currentColor]="'color-text-action'"
                      ></icon>
                      <ng-container
                        *ngTemplateOutlet="toolBadge; context: { $implicit: badgeCount(tile) }"
                      ></ng-container>
                    </span>
                    <span
                      class="tw-text-xs tw-font-medium tw-text-center tw-text-color-text-default"
                      >{{ tile.labelKey | i18n }}</span
                    >
                  </div>
                </ng-template>
                <span
                  class="tw-relative tw-flex tw-items-center tw-justify-center tw-size-14 tw-rounded-[18px] tw-bg-color-surface-elevated tw-shadow-elevation-control"
                >
                  <icon [name]="tile.icon" [size]="6" [currentColor]="'color-text-action'"></icon>
                  <ng-container
                    *ngTemplateOutlet="toolBadge; context: { $implicit: badgeCount(tile) }"
                  ></ng-container>
                </span>
                <span class="tw-text-xs tw-font-medium tw-text-center tw-text-color-text-default">{{
                  tile.labelKey | i18n
                }}</span>
                @if (badgeCount(tile) > 0) {
                  <span class="tw-sr-only">{{ badgeLabel(badgeCount(tile)) }}</span>
                }
              </button>
            }
            <button
              type="button"
              class="tw-flex tw-flex-col tw-items-center tw-gap-[9px] tw-w-[134px]"
              data-testid="tool-tile-add"
              (click)="showStore()"
            >
              <span
                class="tw-flex tw-items-center tw-justify-center tw-size-14 tw-rounded-2xl tw-bg-color-surface-sunken"
              >
                <icon [name]="'plus'" [size]="6" [currentColor]="'color-text-action'"></icon>
              </span>
              <span class="tw-text-xs tw-font-medium tw-text-center tw-text-color-text-action">{{
                "pluginsAddATool" | i18n
              }}</span>
            </button>
          </div>
        </section>

        <!--      plugins-->
        <section
          class="tw-flex tw-flex-col tw-gap-3 tw-p-4 tw-rounded-2xl tw-bg-white/40"
          data-testid="plugins-section"
        >
          <div class="tw-flex tw-items-center tw-gap-2 tw-px-1">
            <span class="tw-text-base tw-font-semibold tw-text-color-text-default">{{
              "pluginsSectionTitle" | i18n
            }}</span>
            <span class="tw-text-[13px] tw-font-medium tw-text-color-text-tertiary">{{
              installedPluginCards.length
            }}</span>
          </div>
          <div class="tw-flex tw-flex-wrap tw-gap-6">
            @for (plugin of installedPluginCards; track plugin.id) {
              <button
                type="button"
                class="tw-flex tw-flex-col tw-gap-4 tw-p-5 tw-w-[264px] tw-text-left tw-overflow-hidden tw-rounded-2xl tw-bg-color-surface-card tw-shadow-elevation-card"
                [attr.data-testid]="'plugin-card-' + plugin.id"
                (click)="openPlugin(plugin)"
              >
                <div class="tw-flex tw-items-center tw-w-full">
                  <span
                    class="tw-flex tw-items-center tw-justify-center tw-size-12 tw-shrink-0 tw-rounded-2xl tw-bg-color-surface-sunken tw-text-base tw-font-semibold tw-text-color-text-secondary"
                    >{{ plugin.title.charAt(0) }}</span
                  >
                  <span class="tw-flex-1"></span>
                  <span
                    class="tw-flex tw-items-center tw-justify-center tw-h-7 tw-min-w-[60px] tw-px-3 tw-rounded-full tw-bg-color-status-success-bg tw-text-[13px] tw-font-medium tw-text-color-status-success-text"
                    >{{ "pluginsStatusActive" | i18n }}</span
                  >
                </div>
                <div class="tw-flex tw-items-center tw-gap-2 tw-w-full">
                  <div class="tw-flex tw-flex-col tw-gap-0.5 tw-flex-1 tw-min-w-0">
                    <span
                      class="tw-truncate tw-text-base tw-font-semibold tw-text-color-text-default"
                      >{{ plugin.title }}</span
                    >
                    <span
                      class="tw-truncate tw-text-[13px] tw-font-medium tw-text-color-text-tertiary"
                      >{{ plugin.type ? plugin.type + " · " + plugin.author : plugin.author }}</span
                    >
                  </div>
                  <icon
                    class=""
                    [name]="'right-arrow'"
                    [size]="5"
                    [currentColor]="'color-text-tertiary'"
                    [disableArrowOverride]="true"
                  ></icon>
                </div>
              </button>
            }
            <button
              type="button"
              class="tw-flex tw-items-center tw-gap-3 tw-px-5 tw-h-[148px] tw-w-[264px] tw-text-left tw-rounded-2xl tw-border-[1.5px] tw-border-dashed tw-border-color-border-strong"
              data-testid="plugin-card-add"
              (click)="showStore()"
            >
              <span
                class="tw-flex tw-items-center tw-justify-center tw-size-12 tw-shrink-0 tw-rounded-2xl tw-bg-color-surface-sunken"
              >
                <icon [name]="'plus'" [size]="6" [currentColor]="'color-text-action'"></icon>
              </span>
              <span class="tw-flex tw-flex-col tw-gap-0.5 tw-flex-1 tw-min-w-0">
                <span class="tw-text-base tw-font-semibold tw-text-color-text-action">{{
                  "pluginsAddAPlugin" | i18n
                }}</span>
                <span class="tw-text-xs tw-font-medium tw-text-color-text-tertiary">{{
                  "pluginsAddAPluginHint" | i18n
                }}</span>
              </span>
            </button>
          </div>
        </section>
      }
    </div>
  } @else {
    <div class="tw-flex tw-flex-col tw-gap-4 tw-w-full" data-testid="plugins-store">
      <!--      back + subtitle-->
      <div class="tw-flex tw-items-center tw-gap-4">
        <button
          type="button"
          class="tw-flex tw-items-center tw-justify-center tw-size-11 tw-shrink-0 tw-rounded-xl tw-text-color-text-secondary"
          data-testid="plugins-back"
          [attr.aria-label]="'pluginsBack' | i18n"
          (click)="showHome()"
        >
          <icon [name]="'left-arrow'" [size]="6" [disableArrowOverride]="true"></icon>
        </button>
        <span class="tw-text-xs tw-font-medium tw-text-color-text-tertiary">{{
          "pluginsCatalogueSubtitle" | i18n: totalCount
        }}</span>
      </div>

      <div
        class="tw-grid tw-grid-cols-[240px_minmax(0,1fr)] tw-gap-4 tw-items-start lg:tw-grid-cols-1"
      >
        <!--      left column: tabs, filters, missing (stacks above the results below lg)-->
        <div class="tw-flex tw-flex-col tw-gap-4">
          <div
            class="tw-flex tw-gap-0.5 tw-p-1 tw-rounded-xl tw-bg-color-surface-sunken tw-shadow-elevation-input"
            role="tablist"
            [attr.aria-label]="'pluginsCatalogueTabs' | i18n"
          >
            @for (tab of ["store", "wishlist"]; track tab) {
              <button
                type="button"
                role="tab"
                class="tw-flex tw-flex-1 tw-items-center tw-justify-center tw-gap-1.5 tw-h-8 tw-px-4 tw-rounded-[9px] tw-text-[13px] tw-font-semibold"
                [ngClass]="
                  selectedTab === tab
                    ? 'tw-bg-color-surface-elevated tw-shadow-elevation-control tw-text-color-text-default'
                    : 'tw-text-color-text-secondary'
                "
                [attr.aria-selected]="selectedTab === tab"
                aria-controls="plugins-results"
                [attr.data-testid]="'store-tab-' + tab"
                [id]="'plugins-tab-' + tab"
                (click)="selectedTab = $any(tab)"
              >
                <span>{{ (tab === "store" ? "pluginTabAll" : "pluginTabSaved") | i18n }}</span>
                <span class="tw-font-medium tw-text-color-text-tertiary">{{
                  tab === "store" ? browsableCount : savedCount
                }}</span>
              </button>
            }
          </div>

          <div
            class="tw-flex tw-flex-col tw-gap-1.5 tw-p-4 tw-rounded-2xl tw-bg-color-surface-card tw-shadow-elevation-card"
            data-testid="plugins-filters"
          >
            <div class="tw-flex tw-items-center tw-justify-between tw-pb-1.5">
              <span class="tw-text-[15px] tw-font-semibold tw-text-color-text-default">{{
                "pluginsFilters" | i18n
              }}</span>
              <button
                type="button"
                class="tw-text-[13px] tw-font-semibold"
                [ngClass]="
                  canClearFilters
                    ? 'tw-text-color-text-action'
                    : 'tw-text-color-text-tertiary tw-cursor-default'
                "
                [disabled]="!canClearFilters"
                data-testid="plugins-clear-filters"
                (click)="clearFilter()"
              >
                {{ "clearAll" | i18n }}
              </button>
            </div>

            <div
              class="tw-flex tw-flex-col tw-gap-1.5"
              role="group"
              aria-labelledby="pluginsFilterType-label"
            >
              <span
                class="tw-pt-2.5 tw-pb-1 tw-text-[11px] tw-font-bold tw-uppercase tw-tracking-[0.08em] tw-text-color-text-tertiary"
                id="pluginsFilterType-label"
                >{{ "pluginsFilterType" | i18n }}</span
              >
              @for (opt of typeOptions; track opt.id) {
                <ng-container
                  *ngTemplateOutlet="
                    filterOption;
                    context: {
                      label: opt.label,
                      count: typeCount(opt.id),
                      on: activeTypes.includes(opt.id),
                      radio: false,
                      group: 'type',
                      id: opt.id,
                    }
                  "
                ></ng-container>
              }
            </div>
            <div
              class="tw-flex tw-flex-col tw-gap-1.5"
              role="radiogroup"
              aria-labelledby="pluginsFilterCategory-label"
            >
              <span
                class="tw-pt-2.5 tw-pb-1 tw-text-[11px] tw-font-bold tw-uppercase tw-tracking-[0.08em] tw-text-color-text-tertiary"
                id="pluginsFilterCategory-label"
                >{{ "pluginsFilterCategory" | i18n }}</span
              >
              @for (opt of categoryOptions; track opt.id) {
                <ng-container
                  *ngTemplateOutlet="
                    filterOption;
                    context: {
                      label: opt.id === allCategories ? ('pluginsAllCategories' | i18n) : opt.id,
                      count: opt.count,
                      on: activeCategory === opt.id,
                      radio: true,
                      group: 'category',
                      id: opt.id,
                    }
                  "
                ></ng-container>
              }
            </div>
            <div
              class="tw-flex tw-flex-col tw-gap-1.5"
              role="group"
              aria-labelledby="pluginsFilterPrice-label"
            >
              <span
                class="tw-pt-2.5 tw-pb-1 tw-text-[11px] tw-font-bold tw-uppercase tw-tracking-[0.08em] tw-text-color-text-tertiary"
                id="pluginsFilterPrice-label"
                >{{ "pluginsFilterPrice" | i18n }}</span
              >
              @for (opt of bundleOptions; track opt.id) {
                <ng-container
                  *ngTemplateOutlet="
                    filterOption;
                    context: {
                      label: opt.label,
                      count: priceCount(opt.id),
                      on: activeBundles.includes(opt.id),
                      radio: false,
                      group: 'bundle',
                      id: opt.id,
                    }
                  "
                ></ng-container>
              }
            </div>
            <div
              class="tw-flex tw-flex-col tw-gap-1.5"
              role="group"
              aria-labelledby="pluginsFilterCountry-label"
            >
              <span
                class="tw-pt-2.5 tw-pb-1 tw-text-[11px] tw-font-bold tw-uppercase tw-tracking-[0.08em] tw-text-color-text-tertiary"
                id="pluginsFilterCountry-label"
                >{{ "pluginsFilterCountry" | i18n }}</span
              >
              @for (opt of countryOptions; track opt.id) {
                <ng-container
                  *ngTemplateOutlet="
                    filterOption;
                    context: {
                      label: opt.label,
                      count: countryCount(opt.id),
                      on: activeCountries.includes(opt.id),
                      radio: false,
                      group: 'country',
                      id: opt.id,
                    }
                  "
                ></ng-container>
              }
            </div>
          </div>

          <div
            class="tw-flex tw-flex-col tw-gap-1.5 tw-p-4 tw-rounded-2xl tw-bg-color-surface-card tw-shadow-elevation-card tw-text-[13px] tw-text-color-text-secondary"
          >
            <span class="tw-text-[15px] tw-font-semibold tw-text-color-text-default">{{
              "pluginsMissingTitle" | i18n
            }}</span>
            <span>{{ "pluginsMissingBody" | i18n }}</span>
          </div>
        </div>

        <!--      right column: search, results-->
        <div
          class="tw-flex tw-flex-col tw-gap-3.5 tw-min-w-0"
          id="plugins-results"
          role="tabpanel"
          [attr.aria-labelledby]="'plugins-tab-' + selectedTab"
        >
          <app-search-input
            class=""
            [sunken]="true"
            [iconLeading]="true"
            [clearable]="true"
            [placeholder]="'searchPlugins' | i18n"
            [(value)]="searchQuery"
          ></app-search-input>

          <div class="tw-flex tw-flex-wrap tw-items-baseline tw-gap-1.5 tw-text-sm">
            <span class="tw-font-bold tw-text-color-text-default">{{
              "pluginsResultsCount" | i18n: displayedPlugins.length
            }}</span>
            @if (searchQuery.trim()) {
              <span class="tw-text-xs tw-font-medium tw-text-color-text-tertiary">{{
                "pluginsResultsFor" | i18n: searchQuery.trim()
              }}</span>
            }
          </div>

          @if (showInstalledNote) {
            <div
              class="tw-flex tw-items-center tw-gap-2 tw-text-[13px] tw-font-medium tw-text-color-text-secondary"
              data-testid="installed-plugins-note"
            >
              <icon [name]="'info-circle'" [size]="4" [currentColor]="'color-text-tertiary'"></icon>
              <span class="tw-flex-1">{{
                (hiddenInstalledPluginCount === 1
                  ? "pluginsInstalledNoteOne"
                  : "pluginsInstalledNoteMany"
                ) | i18n: hiddenInstalledPluginCount
              }}</span>
              <button
                type="button"
                class="tw-flex tw-items-center tw-gap-1 tw-shrink-0 tw-text-[13px] tw-font-semibold tw-text-color-text-action"
                data-testid="installed-plugins-manage"
                (click)="showHome()"
              >
                <span class="">{{ "pluginsInstalledNoteManageLong" | i18n }}</span>
                <span class="tw-hidden">{{ "pluginsInstalledNoteManage" | i18n }}</span>
              </button>
            </div>
          }

          @if (displayedPlugins.length > 0) {
            <div class="tw-grid tw-grid-cols-3 tw-gap-4 xl:tw-grid-cols-2 md:tw-grid-cols-1">
              @for (plugin of displayedPlugins; track plugin.id) {
                <!-- Mouse: the whole card opens details. Keyboard: the title button does, so the card holds no nested interactive roles. -->
                <div
                  class="tw-flex tw-flex-col tw-gap-3 tw-p-4 tw-min-w-0 tw-text-left tw-cursor-pointer tw-rounded-2xl tw-bg-color-surface-card tw-shadow-elevation-card"
                  [attr.data-testid]="'catalogue-card-' + plugin.id"
                  (click)="openFromCard(plugin)"
                >
                  <div class="tw-flex tw-items-start tw-gap-3 tw-min-w-0">
                    <span
                      class="tw-flex tw-items-center tw-justify-center tw-size-10 tw-shrink-0 tw-rounded-xl tw-bg-color-surface-sunken tw-text-[13px] tw-font-semibold tw-text-color-text-secondary"
                      >{{ monogram(plugin) }}</span
                    >
                    <span class="tw-flex tw-flex-col tw-flex-1 tw-min-w-0">
                      <button
                        type="button"
                        class="tw-truncate tw-text-left tw-text-[15px] tw-font-semibold tw-leading-5 tw-text-color-text-default"
                        [attr.data-testid]="'catalogue-open-' + plugin.id"
                        (click)="openFromCard(plugin, $event)"
                      >
                        {{ plugin.title }}
                      </button>
                      <span
                        class="tw-truncate tw-text-xs tw-leading-4 tw-text-color-text-tertiary"
                        >{{ pluginMeta(plugin) }}</span
                      >
                    </span>
                    <button
                      type="button"
                      class="tw-flex tw-items-center tw-justify-center tw-size-7 tw-shrink-0 tw-rounded-lg"
                      [attr.aria-pressed]="!!plugin.isLiked"
                      [attr.aria-label]="
                        (plugin.isLiked ? 'pluginsRemoveFromSaved' : 'pluginsSaveForLater') | i18n
                      "
                      (click)="toggleSaved(plugin, $event)"
                    >
                      <icon
                        [name]="plugin.isLiked ? 'bookmark-on' : 'bookmark'"
                        [size]="5"
                        [currentColor]="
                          plugin.isLiked ? 'color-text-action' : 'color-text-tertiary'
                        "
                      ></icon>
                    </button>
                  </div>
                  <span
                    class="tw-line-clamp-2 tw-min-h-[38px] tw-text-[13px] tw-leading-[19px] tw-text-color-text-secondary"
                    >{{ plugin.description }}</span
                  >
                  <div class="tw-flex tw-items-center tw-justify-between tw-gap-2">
                    <span
                      class="tw-flex tw-items-center tw-h-7 tw-px-3 tw-rounded-full tw-text-xs tw-font-semibold tw-whitespace-nowrap tw-min-w-0 tw-truncate"
                      [ngClass]="
                        isPluginInstalled(plugin.id)
                          ? 'tw-bg-color-status-success-bg tw-text-color-status-success-text'
                          : 'tw-bg-color-surface-sunken tw-text-color-text-secondary'
                      "
                      >{{
                        isPluginInstalled(plugin.id)
                          ? ("pluginsInstalled" | i18n)
                          : priceLabel(plugin)
                      }}</span
                    >
                    <button
                      type="button"
                      class="tw-flex tw-items-center tw-justify-center tw-h-9 tw-px-3.5 tw-shrink-0 tw-rounded-xl tw-text-[13px] tw-font-semibold tw-shadow-elevation-control"
                      [ngClass]="
                        isPluginInstalled(plugin.id)
                          ? 'tw-bg-color-surface-card tw-text-color-text-action'
                          : 'tw-bg-color-intent-brand tw-text-color-text-on-action'
                      "
                      (click)="onCatalogueAction(plugin, $event)"
                    >
                      {{ (isPluginInstalled(plugin.id) ? "pluginsOpen" : "pluginsInstall") | i18n }}
                    </button>
                  </div>
                </div>
              }
            </div>
          } @else {
            <div
              class="tw-flex tw-items-center tw-justify-center tw-p-12 tw-rounded-2xl tw-bg-color-surface-card tw-shadow-elevation-card"
            >
              <span class="tw-text-color-text-tertiary tw-text-base">
                @if (noFilterOptionSelected) {
                  {{ "pluginFilterSelectOption" | i18n }}
                } @else if (searchQuery && searchQuery.trim() !== "") {
                  {{ "noPluginsFoundMatching" | i18n: searchQuery }}
                } @else if (selectedTab === "wishlist") {
                  {{ "pluginsNoSaved" | i18n }}
                } @else {
                  {{ "noPluginsAvailable" | i18n }}
                }
              </span>
            </div>
          }
        </div>
      </div>
    </div>

    <!-- one row of the Filters card: checkbox (or radio for Category) + label + count -->
    <ng-template
      #filterOption
      let-label="label"
      let-count="count"
      let-on="on"
      let-radio="radio"
      let-group="group"
      let-id="id"
    >
      <button
        type="button"
        class="tw-flex tw-items-center tw-gap-2.5 tw-w-full tw-h-9 tw-px-2 tw-rounded-[10px] tw-text-sm tw-text-left"
        [ngClass]="
          on
            ? 'tw-bg-color-surface-elevated tw-shadow-elevation-control tw-font-semibold tw-text-color-text-default'
            : 'tw-text-color-text-secondary'
        "
        [attr.role]="radio ? 'radio' : 'checkbox'"
        [attr.aria-checked]="on"
        (click)="toggleOption(group, id)"
      >
        <span
          class="tw-flex tw-items-center tw-justify-center tw-size-5 tw-shrink-0 tw-text-white"
          [ngClass]="[
            radio ? 'tw-rounded-full' : 'tw-rounded-[5px]',
            on
              ? 'tw-bg-color-intent-brand'
              : 'tw-bg-color-surface-sunken tw-shadow-elevation-input',
          ]"
        >
          @if (on) {
            <icon [name]="'check-only'" [size]="3.5" [disableArrowOverride]="true"></icon>
          }
        </span>
        <span class="tw-flex-1 tw-truncate">{{ label }}</span>
        <span class="tw-text-xs tw-font-normal tw-text-color-text-tertiary">{{ count }}</span>
      </button>
    </ng-template>
  }
</app-page-wrapper>
